import { Schema } from '@core/data/dto/schema';

export const UpdateDeliveryOrderRequestSchema = {
    pickup_at_ready: Schema.String,
    dropoff_address: Schema.String,
    manager_note: Schema.String,
};